import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Col, Divider, Form, Input, InputNumber, Row, message } from "antd";
import { useEffect, useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const MotorZdwForm = (props: iProps) => {

    const { id, sn, refreshTrigger, onRefreshAll } = props

    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearch, setHasSearch] = useState(false);


    const updateForm = async () => {
        let _formValue = {};
        try {
            setIsLoading(true);
            const res = await getDeviceCalibrateResultRequest({ id, sn });
            const data = res.data?.data || {};

            const parseNumber = (v: any) => (v === null || v === undefined || v === '' ? undefined : Number(v));

            _formValue = {
                version: data.version,
                success: parseNumber(data.success),
                c3: parseNumber(data.c3),
                c2: parseNumber(data.c2),
                c1: parseNumber(data.c1),
                c0: parseNumber(data.c0),
                pedalIdleTravel: parseNumber(data.pedalIdleTravel),
                pedalMaxTravel: parseNumber(data.pedalMaxTravel),
                staticC1: parseNumber(data.staticC1),
                staticC0: parseNumber(data.staticC0),
            };
            setHasSearch(true);
        } catch (err) {
            console.error("err", err);
        } finally {
            setIsLoading(false);
            form.setFieldsValue(_formValue);
        }

    }
    useEffect(() => {
        updateForm();
    }, [id, sn, refreshTrigger]);


    const submitForm = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();
            const params = {
                id,
                ...values
            }
            const res = await editDeviceCalibrateResultRequest(params, sn);
            
            if (res.data.code === 0) {
                message.success('下发拉线电机标定结果成功');
                // 提交成功后通知所有表单刷新
                onRefreshAll?.();
            } else {
                message.error('下发拉线电机标定结果失败');
            }
        } catch (error) {
            console.error("submit failed:", error);
            message.error('下发拉线电机标定结果失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>拉线电机标定结果</Divider>
        <Form form={form} labelAlign="left" labelCol={{ span: 6, style: { whiteSpace: 'normal', overflowWrap: 'break-word' } }} wrapperCol={{ span: 14 }}>
            <Form.Item label="参数版本号" name="version" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="标定状态" name="success" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="C3" name="c3" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="C2" name="c2" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="C1" name="c1" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="C0" name="c0" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="静态标定: 空行程" name="pedalIdleTravel" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="静态标定: 最大行程" name="pedalMaxTravel" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="静态标定-x^1系数" name="staticC1" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="静态标定-常数项系数" name="staticC0" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <div style={{ textAlign: 'right' }}>
                <Button
                    type="primary"
                    disabled={!hasSearch}
                    loading={isLoading}
                    onClick={submitForm}
                >
                    下发拉线电机标定结果
                </Button>
            </div>
        </Form>
    </div>
};

export default MotorZdwForm;